import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item', 'checkbox']

  prepareApprove (event) {
    const form = this.element
    const selected = this.selectedItems()

    if (selected.length === 0) {
      event.preventDefault()
      event.stopImmediatePropagation()
      window.alert('Select at least one item to bulk approve.')
      return
    }

    const lines = selected.map((item) => {
      const label = item.dataset.label || 'Item'
      const warnings = (item.dataset.warnings || '').trim()
      return warnings ? `• ${label}: ${warnings}` : `• ${label}`
    })

    const warningCount = selected.filter((item) => (item.dataset.warnings || '').trim().length > 0).length
    const intro = warningCount > 0
      ? `You selected ${selected.length} item(s). ${warningCount} still have missing photos or documents. Open thumbnails above or use Full review before approving.\n\n`
      : `You selected ${selected.length} item(s). Confirm you reviewed the photos and documents shown in the queue.\n\n`

    form.dataset.confirmTitle = 'Bulk approve selected items?'
    form.dataset.confirmMessage = `${intro}${lines.join('\n')}`
    form.dataset.confirmButton = `Approve ${selected.length} selected`
    form.dataset.confirmDestructive = 'false'
  }

  selectedItems () {
    const selectedIds = new Set(
      this.checkboxTargets.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value)
    )

    if (selectedIds.size === 0) return []

    return this.itemTargets.filter((item) => {
      const checkbox = item.querySelector('input[type="checkbox"]')
      return checkbox && selectedIds.has(checkbox.value)
    })
  }
}
